import { FormProps } from "@/components/form";
import { Form } from "@/components/form";
import { z } from "zod/v4";

export const rubroFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
})

export default function RubroForm({
    form,
    ...props
}: FormProps<z.infer<typeof rubroFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="nombre" label="Nombre" />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}